module.exports = __webpack_public_path__ + "static/item--ac--f1@3x.3ddb018a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--ac--f1@3x.png
// module id = 619
// module chunks = 126511778744290